import Vue from 'vue';
import Router from 'vue-router';
import routerConfigFn from './routerConfig';
import options from '../../resource/router/officialSupport';

Vue.use(Router);

export default new Router(routerConfigFn(options));
